/**
 * Generic round badge in the Containers for Change WA palette — a green ring
 * with a lime return-arrow arc around "WA". Not the CFC logo itself; swap in
 * the official artwork (e.g. /brand/cfc-logo.svg) once it's supplied.
 */
export function BrandMark({ className, size = 92 }: { className?: string; size?: number }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label="WARRRL"
    >
      <circle cx="50" cy="50" r="44" fill="none" stroke="#13a874" strokeWidth="7" />
      <path
        d="M24 62 A28 28 0 0 1 70 27"
        fill="none"
        stroke="#6abd5f"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path d="M64 19 L77 26 L66 36 Z" fill="#6abd5f" />
      <text
        x="50"
        y="60"
        textAnchor="middle"
        fontFamily="'Fira Sans Condensed', 'Arial Narrow', sans-serif"
        fontWeight="800"
        fontSize="28"
        fill="#13a874"
      >
        WA
      </text>
    </svg>
  );
}
